const ROOM_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

export {
  ROOM_STATUS
}
